import { render } from "./ProfileCardDetail.vue?vue&type=template&id=2ebeacd9&scoped=true"
import script from "./ProfileCardDetail.vue?vue&type=script&lang=ts"
export * from "./ProfileCardDetail.vue?vue&type=script&lang=ts"

import "./ProfileCardDetail.vue?vue&type=style&index=0&id=2ebeacd9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ebeacd9"

export default script